<template>
  <query-parser v-if="isOpen" v-slot="{ search }">
    <scroll-to-handler v-slot="{ onScrollTo }">
      <component
        :is="appMode"
        v-if="isAppSet"
        :search="search"
        @close="onClose"
        @scroll-to="onScrollTo"
        @onnextstep="$emit('onnextstep', $event)"
        @ontimesnearby="$emit('ontimesnearby', $event)"
        @onbookerror="$emit('onbookerror', $event)"
        @on:ocr_scan="$emit('on:ocr_scan', $event)"
        @on:submitted="$emit('on:submitted', $event)"
        @on:book_success="$emit('on:book_success', $event)"
      ></component>
      <app-error v-else></app-error>
    </scroll-to-handler>
  </query-parser>
</template>

<script>
import store from "@/store";
import config from "@/config";
import AppError from "@/components/AppError";
import AppDefault from "@/components/AppDefault.vue";
import AppSameday from "@/components/AppSameday.vue";
import QueryParser from "@/components/QueryParser";
import ScrollToHandler from "@/components/ScrollToHandler";
// import moment from "moment";

const IS_DEV = process.env.NODE_ENV === "development";
const IS_SAMEDAY = process.env.VUE_APP_MODE === "sameday";

export default {
  name: "App",
  mixins: [config],
  store,
  components: {
    AppError,
    AppDefault,
    AppSameday,
    QueryParser,
    ScrollToHandler,
  },
  created() {
    // Set the initial config
    this.$store.commit("fieldUpdate", {
      value: this.config,
      key: "config",
    });

    // Record the time the app was opened
    // if (moment) {
    //   this.$store.commit("fieldUpdate", {
    //     value: moment(),
    //     key: "startTime",
    //   });
    // }
  },
  data() {
    return {
      isOpen: IS_DEV,
    };
  },
  computed: {
    isAppSet() {
      return this.$store.getters.isAppSet;
    },
    appMode() {
      const mode = IS_SAMEDAY || this.config?.sameday ? "sameday" : "default";
      return `app-${mode}`;
    },
  },
  methods: {
    onOpen(location_id) {
      if (location_id) {
        this.config.locationId = location_id;
        this.$store.commit("fieldUpdate", {
          value: this.config,
          key: "config",
        });
      }

      this.isOpen = !this.isOpen;
    },
    onClose() {
      this.isOpen = false;
    },
  },
};
</script>

<style src="@/main.css"></style>
